export const setURLParam = (key, value) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    urlParams.searchParams.set(key, value);
    history.pushState({}, '', urlParams);
};
export const deletURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    urlParams.searchParams.delete(key);
    history.pushState({}, '', urlParams);
};
export const getURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    return urlParams.searchParams.get(key);
};
export const getAllURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    return urlParams.searchParams.getAll(key);
};
